import React, { useEffect, useState, useMemo, useRef } from "react";
import SelectInput from "./../../components/common/ui/Inputs/SelectInput";
import { DateInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import Table from "../../components/common/table/Table";
import { useDispatch, useSelector } from "react-redux";
import { reportingAction } from "../../_store";
import generateXlsx from "../../components/common/export/generateXlsx";
import { history } from "../../_helpers";
import CustomLoader from "../../components/common/ui/Loader";
import { fDate, getCurrentDate, MinDate, Today } from "../../utils/formatTime";

const DEFAULT_PAGE_NO = 1; // Default page number as a string
const DEFAULT_ROW_COUNT_PER_PAGE = 10; // Default row count per page as a string

// Get the current date
const currentDate = new Date();

// Calculate the start date (180 days ago)
const startDate = new Date(currentDate);
// startDate.setDate(currentDate.getDate() - 180);
startDate.setMonth(currentDate.getMonth() - 6);

// Format the dates in YYYY-MM-DD format (you can change the format as needed)
const formattedStartDate = fDate(startDate);
const formattedEndDate = fDate(currentDate);

function RequestFormActivity() {
  const dispatch = useDispatch();
  const { commonFacilityCode: facilityCode } = useSelector(
    (state) => state.auth
  );
  const reduxManagmentFormtitle = useSelector(
    (state) => state.reporting?.GetManagementRequestFormDropDown
  );
  const reduxOverallReportList = useSelector(
    (state) => state.reporting?.LoadRequestFormTypeResponseTimePercentageList
  );
  const reduxOverallReportLoading = useSelector(
    (state) => state.reporting?.TimePercentageListloading
  );
  const isPageReloading = useSelector((state) => state.master?.isPageReload);
  const user = useSelector((x) => x.auth.user);
  const initialuserActivityData = useSelector(
    (state) => state.reporting?.reqActivityDataSearch
  );
  const ResponseTimePercentageListFullList = useSelector(
    (state) => state.reporting?.ResponseTimePercentageListFullList
  );
  const shouldShowExcelExport = reduxOverallReportList?.DataList?.length > 0;
  const [showSearchFields, setShowSearchFields] = useState(false);

  useEffect(() => {
    const params = {
      ...initialuserActivityData,
      FacilityID: facilityCode,
      managementUserID: user?.ManagementUserID,
    };
    dispatch(reportingAction?.setreqActivityDataSearch(params));
  }, [facilityCode]);

  const statusOptions = [
    { value: 2, label: "Both" },
    { value: 1, label: "Request Opened" },
    { value: 0, label: "Request Closed" },
  ];

  const columns = [
    {
      name: "Form Title",
      selector: (row) => row.RequestFormTitle,
      sortable: true,
      key: "RequestFormTitle",
    },
    {
      width: "120px",
      name: "Response Form Count",
      selector: (row) => row.TotalRequestCount,
      sortable: true,
      key: "TotalRequestCount",
      cell: (row) =>
        row?.TotalRequestCount === 0 ? (
          row?.TotalRequestCount
        ) : (
          <div
            className="Common_Link_Style"
            onClick={() => navigateToAddFormsearch(row)}
          >
            {row.TotalRequestCount}
          </div>
        ),
    },
    {
      width: "190px",
      name: "Total Response Time (Minutes)",
      selector: (row) => {
        const totalMinutes = row.TotalMUFirstRespondTime;
        const totalHours = totalMinutes / 60;
        const formattedHours = totalHours === 0 ? 0 : totalHours.toFixed(2); // Remove decimals if hours are 0
        return (
          <>
            <span>{totalMinutes}</span>
            <br />
            <span className="report-grid-hours">Hours: {formattedHours}</span>
          </>
        );
      },
      key: "TotalMUFirstRespondTime",
      sortable: true,
    },
    {
      width: "190px",
      name: "Average Response Time",
      key: "AverageRespondTime",
      selector: (row) => {
        const totalMinutes = row.AverageRespondTime;
        const totalHours = totalMinutes / 60;
        const formattedHours = totalHours === 0 ? 0 : totalHours.toFixed(2); // Remove decimals if hours are 0
        return (
          <>
            <span>{totalMinutes}</span>
            <br />
            <span className="report-grid-hours">Hours: {formattedHours}</span>
          </>
        );
      },
      //selector: (row) => row.AverageRespondTime,
      sortable: true,
    },
    {
      width: "190px",
      name: "Response Form Count (%)",
      selector: (row) => row.RequestCountPercent,
      sortable: true,
      key: "RequestCountPercent",
    },
    {
      width: "180px",
      name: "Total Response Time (%)",
      selector: (row) => row.RespondTimePercent,
      key: "RespondTimePercent",
      sortable: true,
    },
    {
      width: "170px",
      name: "Average Response (%)",
      selector: (row) => row.AverageRespondTimePercent,
      sortable: true,
      key: "AverageRespondTimePercent",
    },
  ];
  useEffect(() => {
    dispatch(
      reportingAction.GetManagementRequestFormDropDown({
        ...initialuserActivityData,
        mangementUserID: user?.ManagementUserID,
        facilityID: facilityCode,
      })
    );
  }, [facilityCode]);

  useEffect(() => {
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimePercentageList({
        ...initialuserActivityData,
        managementUserID: user?.ManagementUserID,
        FacilityID: facilityCode,
      })
    );
  }, [
    initialuserActivityData?.RowCountPerPage,
    initialuserActivityData?.PageNo,
    facilityCode,
    isPageReloading,
  ]);

  const navigateToAddFormsearch = (row) => {
    const RequestFormType = row?.RequestFormType;
    const RequestFormFrom = parseInt(row?.RequestFormFrom);
    const RequestFormTitle = row?.RequestFormTitle;

    if (!RequestFormType) return; // Early return to exit if PodID is invalid

    history.navigate("/Admin/Reporting/Formsearch", {
      state: {
        id: RequestFormType,
        RequestFormFrom: RequestFormFrom,
        RequestFormTitle: RequestFormTitle,
      }, // Pass the ID securely using state
    });
  };

  const handleManagmentUserSearchSubmit = (e) => {
    e.preventDefault(); // Prevent default form submission behavior
    const updatedRequestSearchForm = {
      ...initialuserActivityData,
      RequestCreateStartDate: initialuserActivityData.RequestCreateStartDate,
      // initialuserActivityData.RequestCreateStartDate === ""
      //   ? formattedStartDate
      //   : initialuserActivityData.RequestCreateStartDate,
      RequestCreateEndDate: initialuserActivityData.RequestCreateEndDate,
      // ? formattedEndDate
      // : initialuserActivityData.RequestCreateEndDate,
      FacilityID: facilityCode,
    };
    dispatch(
      reportingAction?.setreqActivityDataSearch({
        ...updatedRequestSearchForm,
        PageNo: DEFAULT_PAGE_NO,
        RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      })
    );

    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimePercentageList({
        ...updatedRequestSearchForm,
        PageNo: DEFAULT_PAGE_NO,
        RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      })
    ); // Dispatch the action to load POD list
  };


  const handleDateBlur = (e, fieldName) => {
    let { value } = e.target;
    let isFromValid = true;
    let isToValid = true;
    const updatedData = { ...initialuserActivityData };
    if (fieldName === "RequestCreateStartDate") {
      if (
        updatedData.RequestCreateEndDate &&
        new Date(value) > new Date(updatedData.RequestCreateEndDate)
      ) {
        // Invalid: FromDate cannot be after ToDate
        isFromValid = false;
      }
    } else if (fieldName === "RequestCreateEndDate") {
      if (
        updatedData.RequestCreateStartDate &&
        new Date(value) < new Date(updatedData.RequestCreateStartDate)
      ) {
        // Invalid: ToDate cannot be before FromDate
        isToValid = false;
      }
    }

    // Define date format used
    const minDate = MinDate();
    const today = Today();
    const valueDate = new Date(value);
    const isValidDate = valueDate >= minDate && valueDate <= today;

    let updatedParam = {
      ...updatedData,
      RequestCreateStartDate:
        fieldName === "RequestCreateStartDate"
          ? isFromValid && isValidDate
            ? value
            : ""
          : updatedData.RequestCreateStartDate, // preserve existing value
      RequestCreateEndDate:
        fieldName === "RequestCreateEndDate"
          ? isToValid && isValidDate
            ? value
            : ""
          : updatedData.RequestCreateEndDate, // preserve existing value
    };

    dispatch(reportingAction.setreqActivityDataSearch(updatedParam));
  };

  // Function to handle dropdown changes for different fields
  const updateSelectedOption = (selectedOption, name) => {
    
    // Create a shallow copy of the initial log history data
    const paramsCopy = { ...initialuserActivityData, PageNo: DEFAULT_PAGE_NO, RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE, 
};

    // Helper function to update state and params
    const updatePODData = (value) => {
      const updatedValue = value != null ? value : ""; // Allow empty values
      const updatedData = { ...initialuserActivityData, PageNo: DEFAULT_PAGE_NO, RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE };

      // if (name === "RequestCreateStartDate") {

      //   updatedData.RequestCreateStartDate = updatedValue;
      // } else if (name === "RequestCreateEndDate") {
      //   updatedData.RequestCreateEndDate_Show = updatedValue;
      //   updatedData.RequestCreateEndDate = updatedValue;
      // }

      updatedData[name] = updatedValue;
      paramsCopy[name] = updatedValue;

      dispatch(reportingAction?.setreqActivityDataSearch(updatedData));
    };

    // Handle specific cases based on field name
    switch (name) {
      case "RequestFormTypeID":
        updatePODData(parseInt(selectedOption?.value || 0, 10));
        break;
      case "reqCurrentStatus":
        updatePODData(selectedOption ? parseInt(selectedOption.value, 10) : 2);
        break;
      case "RequestCreateStartDate":
      case "RequestCreateEndDate": {
        const formattedDate = selectedOption
          ? selectedOption.toISOString().split("T")[0]
          : "";
        updatePODData(formattedDate);
        break;
      }
      default:
        updatePODData(selectedOption?.label || "");
        break;
    }

    // Add FacilityID and PodID to the params copy
    const updateFacilityID = { ...paramsCopy, FacilityID: facilityCode };

    // Dispatch the action for log history if not dealing with FromDate or ToDate
    if (!["RequestCreateStartDate", "RequestCreateEndDate"].includes(name)) {
      dispatch(
        reportingAction.LoadRequestFormTypeResponseTimePercentageList(
          updateFacilityID
        )
      );
    }
  };

  const resetUserActivity = () => {
    // Default values for reset
    const DEFAULT_RESET_STATE = {
      FacilityID: facilityCode,
      RequestFormTypeID: 0,
      reqCurrentStatus: 2,
      // RequestCreateStartDate_Show: formattedStartDate,
      // RequestCreateEndDate_Show: formattedEndDate,
      RequestCreateStartDate: formattedStartDate,
      RequestCreateEndDate: formattedEndDate,
      managementUserID: user?.ManagementUserID,
      PageNo: DEFAULT_PAGE_NO,
      RowCountPerPage: DEFAULT_ROW_COUNT_PER_PAGE,
      SortBy: "",
    };
    dispatch(reportingAction?.setreqActivityDataSearch(DEFAULT_RESET_STATE));
    // Early return if facilityCode is not available
    if (!facilityCode) return;
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimePercentageList(
        DEFAULT_RESET_STATE
      )
    );
  };

  useEffect(() => {
    if (
      ResponseTimePercentageListFullList &&
      ResponseTimePercentageListFullList?.DataList?.length > 0
    ) {
      // Define the title of the Excel sheet
      const title = "Requests_List_Reporting_OverAll";

      // Define the column headers for Excel
      const generateExcelColumns = [
        "Form Title",
        "Response Form Count",
        "Total Response Time (Minutes)",
        "Average Response Time",
        "Response Form Count (%)",
        "Total Response Time (%)",
        "Average Response (%)",
      ];

      // Map the data for Excel
      const docList = ResponseTimePercentageListFullList?.DataList?.map(
        (obj) => ({
          RequestFormTitle: obj.RequestFormTitle,
          TotalRequestCount: obj.TotalRequestCount?.toString().trim(),
          TotalMUFirstRespondTime: obj.TotalMUFirstRespondTime?.toString().trim(),
          AverageRespondTime: obj.AverageRespondTime?.toString().trim(),
          RequestCountPercent: obj.RequestCountPercent,
          RespondTimePercent: obj.RespondTimePercent,
          AverageRespondTimePercent: obj.AverageRespondTimePercent,
        })
      );

      try {
        // Generate the Excel file with the transformed data
        generateXlsx(docList, generateExcelColumns, title);
        // Clear excel data after the download
        dispatch(reportingAction?.clearResponseTimePercentageListFullList());
      } catch (error) {
        // Handle any errors that occur during Excel generation
        console.error("Error generating Excel file:", error);
      }
    }
  }, [ResponseTimePercentageListFullList]);

  let updatedData = { ...initialuserActivityData };
  const handleDateChange = (name, value) => {
    const date = fDate(value);
    updatedData[name] = date;

    dispatch(reportingAction.setreqActivityDataSearch(updatedData));
  };
  const handleDateEnterKey = (event, name) => {
    if (event.key === "Enter" && updatedData[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      handleDateChange(name, currentDate);
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };



  // ResponseTimePercentageListFullList;
  const generateExcelReport = () => {
    const updateTotalRows = {
      ...initialuserActivityData,
      RowCountPerPage: reduxOverallReportList?.TotalRecordCount,
      exportExcel: true,
      PageNo: 1,
      //FacilityID: facilityCode,
    };

    // Dispatch and process the response
    dispatch(
      reportingAction?.LoadRequestFormTypeResponseTimePercentageList(
        updateTotalRows
      )
    );
  };

  const handleRowPerPage = (page) => {
    const params = {
      ...initialuserActivityData,
      RowCountPerPage: page,
      PageNo: 1,
    };
    dispatch(reportingAction?.setreqActivityDataSearch(params));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }
    const params = { ...initialuserActivityData, PageNo: page };
    dispatch(reportingAction?.setreqActivityDataSearch(params));
  };

  let sorting = false;
  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    const search = { ...initialuserActivityData };
    const newSortOrder = search.SortBy?.includes(column.key)
      ? search.SortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.SortBy = `${column.key} ${newSortOrder}`;
    dispatch(reportingAction?.setreqActivityDataSearch(search));
    dispatch(
      reportingAction.LoadRequestFormTypeResponseTimePercentageList({
        ...initialuserActivityData,
        FacilityID: facilityCode,
        SortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };
  if (reduxOverallReportLoading) {
    return <CustomLoader />;
  }
  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };
  const renderSearch = () => {
    return (
      <form onSubmit={handleManagmentUserSearchSubmit}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <div className="form-floating mb-3">
                <SelectInput
                  options={reduxManagmentFormtitle}
                  value={
                    initialuserActivityData.RequestFormTypeID !== "" ||
                      initialuserActivityData.RequestFormTypeID === 0
                      ? initialuserActivityData.RequestFormTypeID
                      : 0
                  }
                  handleChange={(selectedOption) =>
                    updateSelectedOption(
                      selectedOption,
                      "RequestFormTypeID"
                    )
                  }
                  isMulti={false}
                  closeMenuOnSelect={true}
                  isDisabled={false}
                  isLoading={false}
                  isClearable={
                    initialuserActivityData.RequestFormTypeID
                      ? true
                      : false
                  }
                  //placeholder="--ALL--"
                  label="Form Title"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                options={statusOptions}
                value={initialuserActivityData.reqCurrentStatus}
                handleChange={(selectedOption) =>
                  updateSelectedOption(selectedOption, "reqCurrentStatus")
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={
                  initialuserActivityData.reqCurrentStatus !== 2
                }
                placeholder="--ALL--"
                label="Status"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={initialuserActivityData?.RequestCreateStartDate} // Ensure proper date object
                // handleChange={(selectedOption) => {
                //   updateSelectedOption(
                //     selectedOption,
                //     "RequestCreateStartDate"
                //   );
                // }}
                handleChange={(date) =>
                  handleDateChange("RequestCreateStartDate", date)
                }
                name="FromDate"
                label={"Created Start Date"}
                minDate={new Date(2017, 0, 1)} // Optional if no restriction
                maxDate={
                  initialuserActivityData.RequestCreateEndDate
                    ? initialuserActivityData.RequestCreateEndDate
                    : getCurrentDate()
                } // Restrict max date to ToDate
                required={false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={true}
                isClearable={
                  initialuserActivityData.RequestCreateStartDate
                }
                handleBlur={(e) =>
                  handleDateBlur(e, "RequestCreateStartDate")
                }
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestCreateStartDate")
                }
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <DateInput
                value={initialuserActivityData.RequestCreateEndDate} // Ensure proper date object

                handleChange={(date) =>
                  handleDateChange("RequestCreateEndDate", date)
                }
                name="ToDate"
                minDate={
                  initialuserActivityData.RequestCreateStartDate
                    ? initialuserActivityData.RequestCreateStartDate
                    : new Date(2017, 0, 1)
                } // Restrict min date to FromDate
                maxDate={getCurrentDate()}
                label={"Created End Date"}
                required={false}
                disabled={false}
                yearDropDown={true}
                monthDropDown={true}
                isClearable={initialuserActivityData.RequestCreateEndDate}
                handleBlur={(e) =>
                  handleDateBlur(e, "RequestCreateEndDate")
                }
                handleKeyDown={(e) =>
                  handleDateEnterKey(e, "RequestCreateEndDate")
                }
              />
            </div>
          </div>
        </div>
        {/* Buttons */}
        <div className="mt-3 d-flex flex-wrap justify-content-center gap-3">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          ></Button>
          <Button
            variant="secondary"
            className="me-2"
            onClick={resetUserActivity}
            label={"RESET"}
            type={"button"}
            icon={"fa-solid fa-rotate-right"}
            status={"secondary"}
            disabled={false}
          />
        </div>
      </form>



    );
  };
  return (
    <div>
      <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
        <div className="card b-r-all  p-4 border border-dark-grey mt-3 me-3 w-100">
          {/* <div className="row align-items-center">
            <div className="col-lg-11 col-md-9 col-sm-10 col-8 mb-2">
              {facilityCode !== 0 ? (
                <h3 className="form_title_uppercase text-color">
                  Request Form search
                </h3>
              ) : (
                ""
              )}
            </div>
          </div> */}
          <div className=" d-block d-md-none">
            <div
              className=" d-flex align-items-center justify-content-between"
              style={{ background: "transparent", cursor: "pointer" }}
              onClick={toggleInformation}
            >
              {facilityCode !== 0 ? (
                <h2 className="form_title_uppercase text-color">
                  Request Form search
                </h2>
              ) : (
                ""
              )}
              <i
                id="itagInformation"
                className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                  }`}
                style={{ fontSize: "20px" }}
              ></i>
            </div>
          </div>
          {/* Mobile only (Below md breakpoint) */}
          <div className="d-block d-md-none mt-2">
            {showSearchFields && renderSearch()}
          </div>

          {/* Web only (Desktop and above) */}
          <div className="mb-3 d-none d-md-block">
            <h2 className="form_title_uppercase text-color">
              Request Form search
            </h2>
          </div>
          {/* Web only (Desktop and above) */}
          <div className="d-none d-md-block">{renderSearch()}</div>


        </div>
        <div className=" mt-3 w-100">
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-3">
            <h2 className="form_title_uppercase text-color">
              Overall Request Report
            </h2>
            <div className="d-flex flex-wrap gap-3 align-items-center">
              {shouldShowExcelExport && (
                <ExcelExport
                  variant="soft-gray"
                  handleExcelExport={generateExcelReport}
                />
              )}
            </div>
          </div>
          <Table
            columns={columns}
            data={reduxOverallReportList?.DataList}
            pagination
            onChangeRowsPerPage={handleRowPerPage}
            onChangePage={handlePageChange}
            totalRowCount={reduxOverallReportList?.TotalRecordCount}
            currentPage={initialuserActivityData?.PageNo}
            paginationPerPage={initialuserActivityData?.RowCountPerPage}
            onSort={handleSort}
            serverSideSort
            sortColumn={initialuserActivityData?.SortBy?.split(" ")[0]}
            sortDirection={initialuserActivityData?.SortBy?.split(" ")[1]}
          />
        </div>
      </div>
    </div>
  );
}

export default React.memo(RequestFormActivity);
